import React from "react";
import {
  PartnersContainer,
  PageTitle,
  PartnersGrid,
  PartnerCard,
  PartnerLogo,
  PartnerLink,
  PartnerDetails,
} from "./styles";

import BhanixLogo from "../../assets/ourPartners/Bhanix.png";
import FibeLogo from "../../assets/ourPartners/fibe.png";
import InstaMoneyLogo from "../../assets/ourPartners/instaMoney.png";
import ZypeLogo from "../../assets/ourPartners/Zype_svg_black.png";

const OurPartners = () => {
  return (
    <PartnersContainer>
      <PageTitle>Our Digital Lending Partners</PageTitle>

      <PartnersGrid>
        <PartnerCard>
          <PartnerLink
            href="https://www.Earlysalary.in"
            target="_blank"
            rel="noreferrer"
          >
            <PartnerLogo src={FibeLogo} width="115" alt="Fibe" />
          </PartnerLink>

          <br />

          <PartnerLink
            href="https://www.Earlysalary.in"
            target="_blank"
            rel="noreferrer"
          >
            EarlySalary Service Private Limited
          </PartnerLink>

          <PartnerDetails>
            formerly known as Ashish Securities Private Limited
          </PartnerDetails>

          <PartnerDetails>
            <strong>GRO Details</strong>
            <br />
            <strong>Name:</strong> Mr Amit Nosina
            <br />
            <strong>Tel:</strong> 020-67639797
            <br />
            <strong>Email:</strong> grievance@earlysalary.com
            <br />
            <strong>Customer Care:</strong> Mail to care@earlysalary.com or call
            at 020-67639797
          </PartnerDetails>
        </PartnerCard>

        <PartnerCard>
          <PartnerLink
            href="https://bhanixfinance.com/ourpartners.html"
            target="_blank"
            rel="noreferrer"
          >
            <PartnerLogo src={BhanixLogo} width="130" alt="Bhanix Finance" />
          </PartnerLink>

          <br />

          <PartnerLink
            href="https://bhanixfinance.com/ourpartners.html"
            target="_blank"
            rel="noreferrer"
          >
            BHANIX FINANCE AND INVESTMENT LIMITED (CASHe)
          </PartnerLink>

          <PartnerDetails>
            <strong>GRO Details</strong>
            <br />
            <strong>Name:</strong> Pushpinder Kaur
            <br />
            <strong>Contact No.:</strong> +91 9983107444
            <br />
            <strong>Email:</strong> grievance@Bhanix.in
            <br />
            <strong>Address:</strong> 5th Floor, Paville House, Twin Towers
            Lane, Prabhadevi, Mumbai
            <br />
            <br />
            <strong>Basic Loan Details:</strong>
            <br />
            Instant Digital Personal Loan in 10 minutes
            <br />
            <br />
            Credit Amount : ₹50,000 - ₹3,00,000 (Disbursal Amount)
            <br />
            <br />
            Monthly Interest Rate (reducing balance method) : Upto 3%
            <br />
            <br />
            Repayment Tenure : 9,12 & 18 months
            <br />
            <br />
            Processing Fee : Upto 5.5%
          </PartnerDetails>
        </PartnerCard>

        <PartnerCard>
          <PartnerLink
            href="https://www.instamoney.app/"
            target="_blank"
            rel="noreferrer"
          >
            <PartnerLogo src={InstaMoneyLogo} width="115" alt="InstaMoney" />
          </PartnerLink>

          <br />

          <PartnerLink
            href="https://www.instamoney.app/"
            target="_blank"
            rel="noreferrer"
          >
            Innofin Solutions Pvt. Ltd. (InstaMoney)
          </PartnerLink>

          <PartnerDetails>
            <strong>GRO Details</strong>
            <br />
            Mr. Aditya Shirodkar
            <br />
            <strong>Tel:</strong> 022-48913091
            <br />
            <strong>Email:</strong> grievance@lendenclub.com
          </PartnerDetails>
        </PartnerCard>

        <PartnerCard>
          <PartnerLink
            href="https://www.getzype.com/our-sourcing-partners/"
            target="_blank"
            rel="noreferrer"
          >
            <PartnerLogo src={ZypeLogo} width="130" alt="Zype" />
          </PartnerLink>

          <br />

          <PartnerLink
            href="https://www.getzype.com/our-sourcing-partners/"
            target="_blank"
            rel="noreferrer"
          >
            Easy Platform Services Pvt Ltd (Zype)
          </PartnerLink>

          <PartnerDetails>
            <strong>GRO Details</strong>
            <br />
            <strong>Name:</strong> Mr. Swapnil Kinalekar
            <br />
            <strong>Tel:</strong> 022-28256467
            <br />
            <strong>Email:</strong> support@getzype.com
          </PartnerDetails>
        </PartnerCard>

        <PartnerCard>
          <PartnerDetails>
            <strong>GRO Details</strong>
            <br />
            Mr. Vivek Singh
            <br />
            <strong>Tel:</strong> +91 9820412089
            <br />
            <strong>Email:</strong> vivek@kpaisa.com
          </PartnerDetails>
        </PartnerCard>
      </PartnersGrid>
    </PartnersContainer>
  );
};

export default OurPartners;
